<template>
  <div class="header b_white">
    <div class="b_gray2">
      <div class="w1370 f12 st">
        <div class="d_top clear row clearfix">
          <a :href="`${app}`" class="gray_6">农信商城首页</a>
          <span class="pad15_l gray_6">商城客服：400-810-5353</span>
          <ul class="float-right f12">
            <template v-if="userInfo.id">
              <li class="user-info-panel" id="user"></li>
              <li><a :href="`${logOut}/logout.do`" class="f12 yahei black">退出</a></li>
            </template>
            <template v-else>
              <li class="d_lg"><a :href="`${app}login.do`" class="f12 gray_6">请登录</a></li>
              <li class="d_zc"><a :href="`${passport}register.html`" class="f12 gray_6">免费注册</a></li>
            </template>
            <li>
              <a :href="`${app}login.do`" class="gray_6">我的商城</a><i class="iconfont icon-weibiaoti1fuzhi04 gray_6 f10"></i>
              <div class="z_user w182 clearfix">
                <ul class="float-left">
                  <li><a :href="`${app}order/person/orderList.do`" class="f12 gray_6">我的订单</a></li>
                  <li><a :href="`${app}recommend/page.do`" class="f12 gray_6">采购订货</a></li>
                  <li><a :href="`${app}payment/margin/myMargin.do`" class="f12 gray_6">我的余额</a></li>
                  <li><a :href="`${app}member/favorite/listPage.do`" class="f12 gray_6">我的收藏</a></li>
                  <li><a :href="`${app}bill/page.do`" class="f12 gray_6">账单</a></li>
                  <li><a :href="`${app}v/buyer/receive`" class="f12 gray_6">地址信息</a></li>
                </ul>
              </div>
            </li>
            <li><a :href="`${app}login.do`" class="f12 st gray_6">卖家中心</a><i class="iconfont icon-weibiaoti1fuzhi04 gray_6"></i></li>
            <li>
              <a href="#" class="f12 gray_6">客户服务</a><i class="iconfont icon-weibiaoti1fuzhi04 gray_6"></i>
              <div class="z_user w92">
                <ul>
                  <li><a :href="`${passport}register.html`" class="f12 gray_6">用户注册</a></li>
                  <li><a :href="`${app}goods/tofootindex/shoppingprocessGuide.do`" class="f12 gray_6">购物流程</a></li>
                  <li><a :href="`${app}goods/tofootindex/processEnter.do`" class="f12 gray_6">商家入驻</a></li>
                  <li><a :href="`${app}goods/tofootindex/commonproblemGuide.do`" class="f12 gray_6">常见问题</a></li>
                </ul>
              </div>
            </li>
            <!--            <li>
              <a href="#" class="f12 gray_6">农信产品</a><i class="iconfont icon-weibiaoti1fuzhi04 gray_6"></i>
              <div class="z_user w110">
                <ul>
                  <li><a :href="`${app}`" class="f12 gray_6">国家生猪市场</a></li>
                  <li><a :href="`${app}`" class="f12 gray_6">农信金融</a></li>
                  <li><a :href="`${app}`" class="f12 gray_6">智农通</a></li>
                  <li><a :href="`${app}`" class="f12 gray_6">猪联网</a></li>
                  <li><a :href="`${app}`" class="f12 gray_6">企联网</a></li>
                  <li><a :href="`${app}`" class="f12 gray_6">行情宝 </a></li>
                  <li><a :href="`${app}`" class="f12 gray_6">养猪课堂 </a></li>
                  <li><a :href="`${app}`" class="f12 gray_6">猪病通 </a></li>
                  <li><a :href="`${app}`" class="f12 gray_6">进销财 </a></li>
                </ul>
              </div>
            </li>
            <li><a href="#" class="f12 gray_6">手机版</a></li>-->
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      app: process.env.VUE_APP_APP,
      logOut: window.location.origin,
      passport: process.env.VUE_APP_PASSPORT,
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  watch: {
    userInfo() {
      this.$nextTick(() => {
        window.NxinPlug.identity({
          ele: ".user-info-panel",
          login: `/login?retUrl=${window.location.href}`,
          getList: `${process.env.VUE_APP_OPEN}nxin.usercenter.enterprise.list/5.0`,
          callback: () => {
            window.location.reload(true);
          },
        });
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.NxinPlug.identity({
        ele: ".user-info-panel",
        login: `/login?retUrl=${window.location.href}`,
        getList: `${process.env.VUE_APP_OPEN}nxin.usercenter.enterprise.list/5.0`,
        callback: () => {
          window.location.reload(true);
        },
      });
    });
  },
  methods: {},
};
</script>
